import { useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

import { IoMdClose, IoMdSunny } from "react-icons/io";

import { COMMON_ALT, MENU_LIST } from "../../constant";

import { useLocation, useNavigate, useParams } from "react-router";
import useDeviceType from "../../hook/useDeviceType";
import { useDispatch, useSelector } from "react-redux";
import { CloseMenu, selectMenu, stickyLeft } from "../../redux/action/action";
import MiniMenu from "./MiniMenu";
import ShouldHideMenu, { shouldHideMenu } from "../../utils/hideMenu";
import { stylesConfig } from "../../helpers/stylesConfig";
import { useTranslation } from "react-i18next";
import LanguageSettings from "../Settings/components/LanguageSettings";
import SearchBox from "./components/searchBox";
import BoxWrapper from "./components/boxWrapper";
import BoxItems from "./components/boxItems";
import { iconFilter } from "./components/iconFilter";
import { HiArrowNarrowLeft } from "react-icons/hi";
import useSubTypeList from "../../hook/useSubTypeList";
import ProfileButton from "../PROFILE_SETTING/components/profileButton";
import CustomerNameText from "../PROFILE_SETTING/components/customerNameText";
import Balance from "../Profile/components/balance";
import TopTab from "../Home/components/topTab";
import useCasinoType from "../../hook/useCasinoType";
import { isLoggedIn } from "../../utils/isLoggedIn";
import AnimateWrapper from "../../components/Animate/animateWrapper";
import { Checkbox, Icon, Label } from "semantic-ui-react";
import ColorSwitcher from "./components/colorSwitcher";
import useTriggerMenu, { handleTriggerMenu } from "../../hook/useTriggerMenu";
import { filterType } from "../../hook/useGameListFilter";
import { hiddenSelectIcon } from "../../hook/useHiddenSelectIcon";
import { TbArrowBarLeft, TbArrowBarRight } from "react-icons/tb";
import RouletteBox from "./components/rouletteBox";

const MenuItem = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const { gamePlatform, subType } = useParams();

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;

  const subList = useSubTypeList();
  const casinoType = useCasinoType();

  const menuListKey = Object.keys(MENU_LIST);
  const deviceType = useDeviceType();

  const animationProps = useMemo(() => {
    if (deviceType) {
      return deviceType === "PC"
        ? {
            initial: { x: "0%" },
            animate: { x: "0%" },
            exit: { x: "0%" },
            transition: { duration: 0.2, ease: "easeInOut" },
          }
        : {
            initial: { x: "-100%" },
            animate: { x: "0%" },
            exit: { x: "-100%" },
            transition: { duration: 0.2, ease: "easeInOut" },
          };
    }
  }, [deviceType]);

  const dispatch = useDispatch();
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);
  const isStickyLeft = useSelector((state) => state.isStickyLeft);
  const { game_subtype, sortedByPlatformAndCategoryGames } = isHandleAllGame;

  return (
    <motion.aside
      className={`${isStickyLeft && "!fixed left-0 pb-[60px]"} h-full relative`}
      {...animationProps}
    >
      <section
        className="lg:w-full w-[320px] md:bg-base-white bg-base-light-white md:dark:bg-transparent dark:bg-base-light-dark h-full footer-shadow px-[4px] md:px-[16px] overflow-y-scroll no-scrollbar py-common-padding-y"
        onClick={(event) => {
          event.stopPropagation();
        }}
      >
        <section className="lg:hidden md:pt-[16px] w-full flex items-start justify-between text-white mb-[10px]">
          {isLoggedIn() ? (
            <div className="flex gap-[5px]">
              <ProfileButton
                path="profile/"
                className="bg-base-light-white text-base-dark dark:bg-base-input-gray dark:text-base-white"
              />
              <div className="flex flex-col justify-between">
                <CustomerNameText className="font-medium tracking-tighter text-light-text !text-base" />
                <Balance className="dark:text-base-white text-base-dark !text-base" />
              </div>
            </div>
          ) : (
            <img
              className="w-[80px] h-[40px] object-cover"
              src={stylesConfig.mainLogo}
              alt={COMMON_ALT}
            />
          )}

          <div className="">
            <LanguageSettings />
          </div>
        </section>
        <section className="md:hidden">
          <TopTab />
        </section>
        <section className="hidden md:flex justify-end">
          {isStickyLeft ? (
            <TbArrowBarRight
              onClick={() => {
                dispatch(stickyLeft());
              }}
              className="dark:text-base-light-white text-base-light-dark text-xl cursor-pointer"
            />
          ) : (
            <TbArrowBarLeft
              onClick={() => {
                dispatch(stickyLeft());
              }}
              className="dark:text-base-light-white text-base-light-dark text-xl cursor-pointer"
            />
          )}
        </section>
        <section className="my-[20px] mb-[10px]">
          <SearchBox />
        </section>
        {/* <section className="my-[10px]">
          <RouletteBox />
        </section> */}
        <section className="flex flex-col gap-[10px]">
          <BoxWrapper>
            {/* {gamePlatform && gamePlatform !== "all" ? (
              <BoxItems
                icon={<HiArrowNarrowLeft className="text-2xl mr-[10px] " />}
                text={"BackToLobby"}
                wrapperTextClassName={`${isStickyLeft && "!hidden"}`}
                path={`/${casinoType}`}
              />
            ) : null} */}
            {subList?.map((list, index) => {
              const hiddenIcon = hiddenSelectIcon({
                iconName: list,
                casinoType: casinoType,
              });

              const isEmptyList =
                gamePlatform && gamePlatform !== "all" && index > 2
                  ? Boolean(
                      filterType({
                        gameList:
                          sortedByPlatformAndCategoryGames?.[gamePlatform]?.[
                            list
                          ],
                        casinoType: casinoType,
                      })?.length === 0
                    )
                  : false;
              const backgroundClass = handleTriggerMenu(
                "!text-main-color !bg-menu-background-hover",
                list,
                {
                  pathname,
                  casinoType,
                  subType,
                }
              );
              const textClass = handleTriggerMenu("!text-main-color", list, {
                pathname,
                casinoType,
                subType,
              });
              return (
                <BoxItems
                  notTranslate={casinoType === "promotion"}
                  onClick={() => {
                    dispatch(CloseMenu());
                  }}
                  wrapperClassName={`${backgroundClass} ${
                    isEmptyList && "hidden"
                  } ${hiddenIcon}`}
                  wrapperTextClassName={`${textClass} ${
                    isStickyLeft && "!hidden"
                  }`}
                  icon={iconFilter(list)}
                  text={list}
                  path={
                    casinoType === "promotion"
                      ? `/${casinoType}/detail/${index}`
                      : casinoType === "terms"
                      ? `/terms/${list}`
                      : list === "Home"
                      ? `/${casinoType}`
                      : `/${casinoType}/category/${
                          gamePlatform || "all"
                        }/${list}`
                  }
                />
              );
            })}
          </BoxWrapper>
          <section className="md:hidden flex flex-col gap-[10px] px-[10px] py-[3px]">
            <ColorSwitcher />
          </section>
        </section>
      </section>
      <IoMdClose
        className="md:hidden absolute top-0 right-[35px] text-3xl mt-[10px] text-light-gray cursor-pointer"
        onClick={() => dispatch(CloseMenu())}
      />
    </motion.aside>
  );
};

export default MenuItem;
